import {useQuery} from "@tanstack/react-query";
import {fetchGraphQL} from "../../../utils/gql-utils";
import {getGraphQLUrl} from "../../../web3/apollo/client";

export const useGetChartV2Data = (enabled?: boolean) => {
  const query = useQuery({
    queryKey: ["charts-v2"],
    queryFn: async () => {
      const url = getGraphQLUrl();
      return await fetchGraphQL(
        url,
        `
        query {
          dailyData: muteSwitchDayDatas(first: 1000, orderBy: date, orderDirection: desc) {
            d: date
            v: dailyVolumeUSD
            l: totalLiquidityUSD
            # t: txCount
          }
        }
      `,
      ).then(({data}) =>
        (data.dailyData as any[]).map(({d, v, l, t}: Record<string, number>) => ({
          date: d * 1000,
          volume: +v,
          liquidity: +l,
          // txCount: +t,
        })),
      );
    },
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    ...query,
    chartData: query.data || [],
  };
};
